<template>
  <div class="text-xs font-semibold tracking-widest uppercase">
    <slot />
  </div>
</template>
